import React from "react";

// Circular avatar with the Google-style 4-color ring.
// Fallback: initial letter on black/magenta (Kuryarti style).
export default function GoogleAvatar({ user, size = 28, ring = true, className = "" }) {
  const picture = user?.picture;
  const initial = (user?.name || user?.email || "?").trim().charAt(0).toUpperCase();

  const ringStyle = ring
    ? {
        background:
          "conic-gradient(from 90deg, #EA4335, #FBBC05, #34A853, #4285F4, #EA4335)",
      }
    : {};

  const inner = picture ? (
    <img
      src={picture}
      alt=""
      className="w-full h-full object-cover rounded-full"
      referrerPolicy="no-referrer"
    />
  ) : (
    <span
      className="w-full h-full flex items-center justify-center rounded-full font-mono font-bold bg-[#0a0a0a] text-white"
      style={{ fontSize: size * 0.42 }}
    >
      {initial}
    </span>
  );

  const pad = Math.max(1, Math.round(size * 0.08));
  return (
    <span
      className={`inline-flex items-center justify-center rounded-full shrink-0 ${className}`}
      style={{ width: size, height: size, ...ringStyle, padding: pad }}
    >
      {inner}
    </span>
  );
}
